export function getBaseUrl() {
  return process.env.REACT_APP_API_BASE_URL;
}

export function getDefaultRoute() {
  return process.env.REACT_APP_DEFAULT_ROUTE;
}

export function getPatientLabel() {
  return {
    single: process.env.REACT_APP_PATIENT_LABEL_SINGLE,
    plural: process.env.REACT_APP_PATIENT_LABEL_PLURAL,
  };
}

export function getLogo() {
  return process.env.REACT_APP_MAIN_LOGO;
}

export function getLoginMessage() {
  return process.env.REACT_APP_LOGIN_MESSAGE;
}

export function getCurrentThemeValue() {
  return process.env.REACT_APP_CURRENT_THEME;
}

export function getIPAWorklistTitle() {
  return {
    single: process.env.REACT_APP_IPA_WORKLIST_SINGLE ?? "Individual Patient Application",
    plural: process.env.REACT_APP_IPA_WORKLIST_PLURAL ?? "Individual Patient Applications",
  };
}

export function getIPAAppealsTitle() {
  return {
    single: process.env.REACT_APP_IPA_APPEAL_TITLE_SINGLE ?? "Appeal",
    plural: process.env.REACT_APP_IPA_APPEAL_TITLE_PLURAL ?? "Appeals",
  };
}
export function freeTextOnlyOnIndicationInput() {
  return process.env.REACT_APP_IPA_FREE_TEXT_ONLY_ON_INDICATION_INPUT === "TRUE" || process.env.REACT_APP_IPA_FREE_TEXT_ONLY_ON_INDICATION_INPUT === "true";
}

export function useCreatableCodeSetValueSelectorOnTreatmentForm() {
  return process.env.REACT_APP_IPA_USE_CREATABLE_CODE_SET_VALUE_SELECTOR_ON_TREATMENT_FORM === "TRUE" || process.env.REACT_APP_IPA_USE_CREATABLE_CODE_SET_VALUE_SELECTOR_ON_TREATMENT_FORM === "true";
}

export function getShouldIPAReportBackButtonShowText() {
  return process.env.REACT_APP_IPA_REPORT_BACK_TEXT_BUTTON === "TRUE" || process.env.REACT_APP_IPA_REPORT_BACK_TEXT_BUTTON === "true";
}

export function getIPARequestFurtherTreatmentTitle() {
  return process.env.REACT_APP_IPA_REQUEST_ONGOING_TREATMENT_TITLE ?? "Request Ongoing Treatment";
}

export function getSignalRHubAddress() {
  return process.env.REACT_APP_SIGNALR_HUB_ADDRESS;
}

export function isSignalREnabled() {
  return process.env.REACT_APP_SIGNALR_ENABLED === "TRUE" || process.env.REACT_APP_SIGNALR_ENABLED === "true";
}

export function showSignalRError() {
  return process.env.REACT_APP_SIGNALR_SHOW_ERROR === "TRUE" || process.env.REACT_APP_SIGNALR_SHOW_ERROR === "true";
}

export function getDraggableDialogs() {
  return process.env.REACT_APP_DRAGGABLE_DIALOGS === "TRUE" || process.env.REACT_APP_DRAGGABLE_DIALOGS === "true";
}

export function getIPACollapseRestrictionHtml() {
  return process.env.REACT_APP_IPA_COLLAPSE_RESTRICTION_HTML === "TRUE" || process.env.REACT_APP_IPA_COLLAPSE_RESTRICTION_HTML === "true";
}
